import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { useGoogleAnalyticsContext, useWebStoreContext } from "contexts";
import { useAppDispatch } from "hooks";
import { DripOfferResponse } from "interfaces/drip-offer";
import { FeatureType } from "interfaces/feature-tracker";
import { useEffect } from "react";
import { featureTrackerAPI } from "redux/apis";
import { onClosePopUp } from "redux/slices";
import { Body, Container, Text, Title } from "./styles";

interface DripOfferInfoProps {
	index: number;
}

export const DripOfferInfo: React.FC<DripOfferInfoProps> = ({
	index
}: DripOfferInfoProps) => {
	const dispatch = useAppDispatch();
	const scale = useCalculateScale(378, 380);
	const { authToken } = useWebStoreContext();
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();

	const { data }: { data?: DripOfferResponse } =
		featureTrackerAPI.endpoints.getFeatureTrackers.useQueryState({
			FeatureType: FeatureType.DRIP_OFFER,
			isAuthenticated: !!authToken?.value
		});

	const onClose = () => {
		dispatch(onClosePopUp());
	};

	useEffect(() => {
		reportEvent("drip_offer", {
			source: "info_button_click"
		});
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "drip_offer",
			event_type: "drip_offer",
			action: "info_button_click",
			source: "drip_offer",
			type: "drip_offer_info"
		});
	}, []);

	useEffect(() => {
		index === -1 && onClose();
	}, [index]);

	return (
		<Container scale={scale}>
			<CloseIconButton onClose={onClose} />
			<Body>
				<Title>Login Everyday</Title>
				<Text>
					To claim the rest of your prizes, login every day for a new prize from
					this offer.
				</Text>
				<Title>
					{data?.trackers?.[index]?.claimDurationDays} Days to Claim All Rewards
				</Title>
				<Text>
					To receive all prizes, you have{" "}
					{data?.trackers?.[index]?.claimDurationDays} consecutive days to claim
					all prizes from date of purchase.
				</Text>
			</Body>
		</Container>
	);
};
